export default __webpack_public_path__ + "static/media/5.2e6ec192.mp3";